<template>
	<div class="wrapper">
		<div class="info">
			<div class="tl">
				<div class="tl-img-box">
					<img class="play-acution" src="@/assets/images/play-circle.png" alt="" @click="playYoutube" v-if="goodsInfo.video_id && goodsInfo.video_id != ''" />

					<div class="youtube-player" v-show="videoShow" v-if="goodsInfo.video_id && goodsInfo.video_id != ''">
						<video-player
							style="width: 100%; height: 100%"
							class="video-player vjs-custom-skin"
							ref="videoPlayer"
							:playsinline="true"
							:options="playerOptions"
						></video-player>
					</div>
					<vue-magnify :previewImg="currentImg" class="vueMagnify" :zoomImg="currentImg"></vue-magnify>
				</div>
				<div class="tl-tabs">
					<div class="prev" @click="scrollPrev" :class="{ disabled: currentPicImg == 0 }"><i class="icon iconfont iconprev"></i></div>
					<div class="next" v-if="productImgList && productImgList.length" @click="scrollNext" :class="{ disabled: currentPicImg == productImgList.length - 1 }">
						<i class="icon iconfont iconnext"></i>
					</div>
					<div class="img-list-box">
						<ul class="img-tabs" :style="{ width: ulWidth, left: ulLeft + 'px' }">
							<li v-for="(img, index) in productImgList" :key="index" :class="{ active: currentPicImg == index }" @click="changeShowImg(img, index)">
								<img v-lazy="img" alt :key="img" />
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="descBox">
				<div class="descTop">
					<p class="goodsName">{{ goodsInfo.name }}</p>
					<p class="type">{{ goodsInfo.brief }}</p>
					<div class="priceBox">
						<p>
							价格
							<span class="price">{{ goodsInfo.point }}</span>
							<span style="color:#FE4706">积分</span>
							<span class="price" v-if="goodsInfo.open_point == 1">+￥{{ goodsInfo.price }}</span>
						</p>
						<!-- <p style="margin-top: 8px;">每人每月限兑换1份</p> -->
					</div>
					<template v-if="product.default_spes_desc">
						<div class="tr-group" v-for="(value, key, i) in product.default_spes_desc" :key="i">
							<div class="tr-title-left">{{ key }}</div>
							<div class="tr-right">
								<div class="color" v-for="(item, index) in value" :key="index" :class="{ active: item.is_default }" @click="changeSpes(item.product_id)">
									<a href="javascript:;">{{ item.name }}</a>
								</div>
							</div>
						</div>
					</template>
					<!-- <div class="tr-group" v-if="product.default_spes_desc">
						<div class="tr-title-left">颜色</div>
						<div class="tr-right">
							<div class="colorSelBox">
								<span class="colorSelect">黑色</span>
							</div>
						</div>
					</div> -->
					<div class="tr-group">
						<div class="tr-title-left">数量</div>
						<div class="tr-right">
							<el-input-number v-model="buyNum" @change="handleChange" :min="1" label="购买数量" size="small" :max="buyMax"></el-input-number>
						</div>
					</div>
				</div>
				<el-button class="pay-btn" @click="buyNow()" v-if="(open_point_exchange == 1)"><div class="line1">立即兑换</div> </el-button>

				<div class="exchange-tips" v-else>活动暂未开启</div>
			</div>
			<div class="rinkBox"  v-if="pointDetailAd.length>0">
				<!-- 广告位 -->
				<img class="adImg" :src="pointDetailAd[0].img" @click="swiperClick(pointDetailAd[0])" v-if="pointDetailAd.length>0"/>
			</div>
		</div>
		<div class="detailBox">
			<div class="left">
				<p class="titleDe">商品详情</p>
				<div id="detail"><div class="shop-info-item" v-html="goodsInfo.intro"></div></div>
			</div>

			<!-- <div class="right ">
				<div class="qrcodeBox">
					<p>扫码兑换</p>
					<div id="qrcode" ref="qrcode" class="qrcode" ></div>
				</div>
				<div class="title">热门活动推荐</div>
				<div class=" recommend"  v-for="(item, index) in saleRanking" :key="index" @click="toDetails(item.id)">
					<img v-lazy="item.cover_img" alt="" />
					<p>{{ item.name }}</p>
					
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
import QRCode from 'qrcodejs2';
import vueMagnify from '@/components/vue-magnify/index.vue';
import { timeToDate } from '@/utils';
import { mapActions, mapState } from 'vuex';
// import Msg from '../components/msg.vue';
import MsgList from '@/components/msg/MsgList.vue';
import { apiBaseUrl } from '@/config/env.js';
import { showLoading, hideLoading } from '../../utils/loading';
import { isSafeRedirect } from '@/utils';
export default {
	name: 'goodsDetail',
	components: { vueMagnify, MsgList },
	props: {},
	data() {
		return {
			toTopShow: false,
			buyNum: 1,
			goodsId: '',
			imgList: [],
			ulLeft: 0,
			isEnd: false,
			goodsInfo: {}, //商品详情
			product: {}, // 规格详情
			isFav: false, //收藏
			goodsParams: null, //商品参数信息
			goodsComments: {
				count: 0,
				page: 1,
				limit: 15,
				list: null
			}, // 商品评论信息, //商品评论信息
			currentImg: '', //列表选中图片
			selectCommentImg: '', //评论选中图片
			selectCommentImgIndex: null, //评论选中图片
			selectCommentIndex: null, //评论选中图片
			loadingShow: false,
			saleRanking: [], //销量排行榜
			videoShow: false,
			currentPicImg: 0,
			pointDetailAd:[],//顶部右侧广告图
		};
	},
	watch: {
		$route(to, from) {
			if (to.name == 'goodsDetail') {
				let goodsId = this.$route.query.id;
				if (goodsId) {
					this.goodsId = goodsId;
					this.getAllInfo();
				}
			}
			if (this.$route) {
				this.buyNum = 1;
			}
		}
	},
	computed: {
		...mapState({
			open_point_exchange: state => state.config.open_point_exchange
		}),
		ulWidth() {
			if (this.goodsInfo.album) {
				return this.goodsInfo.album.length * 62 + 'px';
			}
			return 0 + 'px';
		},
		prevDisabled() {
			return this.ulLeft == 0;
		},
		nextDisabled() {
			if (this.goodsInfo.album) {
				return this.goodsInfo.album.length <= 5 || this.isEnd;
			}
			return false;
		},
		buyMax() {
			return this.product.stock;
		},
		productImgList() {
			return this.goodsInfo.album;
		}
	},
	methods: {
		...mapActions(['getCartNumsAction']),
		playYoutube() {
			this.videoShow = true;
			this.$nextTick(() => {
				this.$refs.videoPlayer.player.play();
			});
		},
		handleChange(value) {},
		scrollPrev() {
			// this.ulLeft = 0;

			if (this.currentPicImg == 0) {
				return;
			}
			this.currentPicImg--;
			this.currentImg = this.productImgList[this.currentPicImg];

			if (this.productImgList.length - 4 <= this.currentPicImg) {
				return;
			}

			let num = this.currentPicImg;
			this.ulLeft = -60 * num;
		},
		scrollNext() {
			if (this.productImgList.length - 1 == this.currentPicImg) {
				return;
			}
			this.currentPicImg++;
			this.currentImg = this.productImgList[this.currentPicImg];

			if (this.productImgList.length - 4 <= this.currentPicImg) {
				return;
			}
			let num = this.currentPicImg;

			if (this.productImgList.length <= 5) {
				return;
			}
			this.ulLeft = -60 * num;

			// let num = this.productImgList.length - 5;
			// let left = 54 * num + 24;
			// this.ulLeft = -left;
			// this.isEnd = true;
		},
		//切换显示图片
		changeShowImg(img, idx) {
			this.currentPicImg = idx;
			if (this.productImgList.length > 5) {
				if (idx >= this.productImgList.length - 5) {
					this.ulLeft = -60 * (this.productImgList.length - 5);
				}
			}
			this.currentImg = img;
			this.videoShow = false;
			setTimeout(() => {
				this.$refs.videoPlayer && this.$refs.videoPlayer.player.pause();
			}, 200);
		},
		returnTo(id) {
			// document.getElementById(id).scrollIntoView({behavior: "smooth"})
			document.getElementById(id).scrollIntoView();
		},
		getAllInfo() {
			this.getGoodsDetail();
			this.getPointAd();
		},
		getGoodsDetail() {
			let data = {
				id: this.goodsId
			};
			let userToken = this.$storage.get('userToken');
			if (userToken) {
				data['token'] = userToken;
			}
			this.$api.addRecord({
				'type': '7',
				'api_method': "goods.getdetial",
				"platform": "1",
				"code": '',
				"rel_id": this.goodsId
			})
			showLoading();
			this.$api.goodsDetail(data).then(res => {
				if (res.status == true) {
					let info = res.data;
					this.goodsInfo = info;
					if (this.goodsInfo.video_id != '') {
						this.playerOptions.sources[0].src = this.goodsInfo.video.video_url;
						this.playerOptions.poster = this.goodsInfo.video.video_cover;
					}
					console.log(this.goodsInfo);
					this.product = res.data.product;
					this.isFav = info.isfav === 'true' ? true : false;
					this.currentImg = this.goodsInfo.album[0];
				}
				hideLoading();
			});
		},
		//切换商品规格
		changeSpes(id) {
			this.$api.getProductInfo({ id }).then(res => {
				if (res.status) {
					this.product = res.data;
				}
			});
		},
		handleScroll() {
			this.scrollTop = this.scrollTop = window.pageYOffset || document.body.scrollTop;
			if (this.scrollTop > 500) {
				this.toTopShow = true;
			} else {
				this.toTopShow = false;
			}
		},
		scrollToTop() {
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		},
		// 立即购买
		buyNow() {
			if (this.buyNum > 0) {
				let data = {
					product_id: this.product.id,
					nums: this.buyNum,
					type: 2 ,// 区分加入购物车和购买
					order_type:13//
				};
				this.$api.addCart(data).then(res => {
					if (res.status) {
						let cartIds = res.data;
						this.$router.push({
							name: 'order',
							query: { cart_ids: JSON.stringify(cartIds), ordertype:"13"}
						});
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
				})
			}
		},
		qrcode() {
			let qrcode = new QRCode('qrcode', {
				width: 200, // 二维码宽度，单位像素
				height: 200, // 二维码高度，单位像素
				text: `${apiBaseUrl}wap/pageactivity/point/Detail?id=${this.goodsId}` // 生成二维码的链接
			});
		},
		getSalesRanking() {
			this.$api.auctionList({ is_rec: 1 }).then(res => {
				if (res.status) {
					this.saleRanking = res.data.list.splice(0, 6);
				}
			});
		},
		toDetails(id) {
			let { href } =  this.$router.resolve({
				name: 'auction',
				params: { goodsId: id }
			});
			if (!isSafeRedirect(href)) {
				console.warn('非白名单域名，禁止跳转:', href);
				return;
			}
			window.open(href, '_blank')
		},
		getPointAd(){
			let data = {
				codes: ["point_detail"]
			};
			let _this = this;
			this.$api.getCarouselLists(data).then(res => {
				console.log(res);
				if (res.status) {
					if(res.data.list.point_detail){
						_this.pointDetailAd = res.data.list.point_detail;
					}
				}
			});
		},
		// /点击
		swiperClick(v) {
			// type 1 url 直接跳转
			// 2 商品
			//  3 文章
			// 4  文章分类
			// 5 智能表单
			this.$api.addRecord({
				'type': '5',
				'api_method': "advert.getcarousellists",
				"platform": "1",
				"code": v.code,
				"rel_id": v.id
			})
			if (v.type == 1 && v.val!='#') {
				if (isSafeRedirect(v.val)) {
					window.open(v.val, '_blank')
				}
				return
			}
			
			if (v.type == 2) {
				this.$router.push({
					path: `detail/${v.val}`,
				})
				return
			}
		},
	},
	created() {},
	mounted() {
		//this.$api.addRecord({ type: '2', api_method: 'goods.getdetial', rel_id: this.$route.params.goodsId, platform: '1' });

		let goodsId = this.$route.params.id;
 
		//let goodsId = this.$route.query.id;
		this.goodsId = goodsId;

		this.getAllInfo();
		this.$nextTick(function() {
			window.addEventListener('scroll', this.handleScroll);
		});
		this.$nextTick(() => {
			this.qrcode();
		});
		// 获取销量排行榜
		// 获取推荐榜
		this.getSalesRanking();
	}
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.wrapper {
	width: 1225px;
	margin: 0 auto;
}
.displayC {
	display: flex;
	align-items: center;
}
.info {
	display: flex;
	background-color: #fff;
	margin: 15px 0;
	/* 	.t {
		display: flex;
		padding-bottom: 30px; */
	.tl {
		padding: 26px 0 26px 26px;

		.tl-img-box {
			width: 350px;
			height: 350px;
			border: 1px solid $border;
			margin-bottom: 20px;
			position: relative;
			.play-acution {
				position: absolute;
				left: 10px;
				bottom: 10px;
				width: 40px;
				height: 40px;
				z-index: 9;
			}
			.youtube-player {
				position: absolute;
				left: 0;
				top: 0;
				width: 350px;
				height: 350px;
				z-index: 9;
			}
			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
		.tl-tabs {
			height: 54px;
			position: relative;
			.img-list-box {
				width: 310px;
				height: 54px;
				margin: 0 auto;
				position: relative;
				overflow: hidden;
				padding-bottom: 4px;
				ul {
					position: absolute;
					left: 0;
					top: 0;
					height: 54px;
					transition: left 0.15s linear;
					li {
						width: 60px;
						height: 54px;
						float: left;
						display: flex;
						align-items: center;
						// margin: 0 4px;
						border: 1px solid $border;
						padding: 1px;
						box-sizing: border-box;
						&.active {
							border: 2px solid $theme-color;
							padding: 0;
						}
						&:hover {
							border: 2px solid $theme-color;
							padding: 0;
						}
						img {
							// width: 100%;
							// height: 100%;

							width: 54px;
							height: 54px;

							object-fit: cover;
						}
					}
				}
			}
			.prev {
				position: absolute;
				left: -5px;
				top: 50%;
				width: 26px;
				height: 26px;
				margin-top: -16px;
				cursor: pointer;
				&.disabled {
					cursor: not-allowed;
					.icon {
						color: $border;
					}
				}
				.icon {
					font-size: 26px;
					color: #757575;
				}
			}
			.next {
				position: absolute;
				right: -5px;
				top: 50%;
				width: 26px;
				height: 26px;
				margin-top: -16px;
				cursor: pointer;
				&.disabled {
					cursor: not-allowed;
					.icon {
						color: $border;
					}
				}
				.icon {
					font-size: 26px;
					color: #757575;
				}
			}
		}
	}
	.tr {
		flex: 1;
		position: relative;
		.tr-title {
			font-weight: 700;
			color: #666;
			padding-top: 10px;
			line-height: 28px;
			font-size: 18px;
			margin-bottom: 5px;
		}
	}
	.tr-desc {
		font-size: 14px;
		margin-bottom: 20px;
		line-height: 20px;
	}
	.tr-group {
		margin-top: 20px;
		margin-bottom: 15px;
		position: relative;
		display: flex;
		&.underline {
			padding-bottom: 10px;
			border-bottom: 1px solid $border;
		}
		.tr-title-left {
			color: #838383;
			font-size: 12px;
			display: inline-block;
			width: 60px;
			height: 32px;
			line-height: 32px;
		}
		.tr-right {
			display: inline-block;
			flex: 1;
			.colorSelBox{
				display: flex;
				align-items: center;
				height: 100%;
			}
			.colorSelect{
				padding: 3px 5px;
				background-color: #999;
				color: #fff;
				margin-right: 8px;
				border-radius: 3px;
				font-size: 12px;
			}
			.now-price {
				color: $theme-color;
				text-align: left;
				margin-right: 20px;
				i {
					font-size: 16px;
				}
				.price-num {
					font-size: 22px;
				}
			}
			.old-price {
				color: #666;
				font-size: 12px;
			}
			.cx-item {
				padding: 2px 4px;
				background: $theme-color;
				color: #fff;
				margin-right: 10px;
				font-size: 12px;
				height: 24px;
				line-height: 24px;
			}
			.color,
			.size {
				font-size: 12px;
				border: 1px solid #b8b7bd;
				margin-right: 8px;
				display: inline-block;
				height: 28px;
				line-height: 28px;
				margin-bottom: 12px;
				&.active {
					border-color: $theme-color;
					background: $theme-color;
					color: #fff;
				}
				a {
					display: block;
					padding: 0 10px;
				}
				&:hover {
					border: 1px solid $theme-color;
				}
			}
			.weight {
				font-size: 12px;
			}
			.kc {
				color: #878787;
				display: inline-block;
				font-size: 12px;
				margin-left: 20px;
			}
		}
		/* } */
	}
	.showImg {
		width: 360px;
		height: 360px;
		border-radius: 10px;
		display: inline-block;
	}
	.descBox {
		flex: 1;
		padding: 26px 25px 20px 34px;
		color: #1a1a1a;
		.goodsName {
			font-size: 18px;
			font-weight: 500;
		}
		.type {
			color: #ed3e3b;
			font-size: 14px;
			margin: 7px 0 18px;
		}
		.priceBox {
			display: flex;
			flex-direction: column;
			justify-content: space-around;
			padding: 18px;
			height: 80px;
			background: rgba(255, 192, 0, 0.2);
			box-sizing: border-box;
		}
		.price {
			color: #fe4706;
			font-weight: 700;
			font-size: 24px;
		}
		.title {
			width: 80px;
			color: #999;
			margin: 20px 0;
		}
		.colorImg {
			width: 44px;
			height: 44px;
		}
	}
	.el-button {
		width: 180px;
		height: 50px;
		background: #ffc300;
		/* border-radius: 10px; */
		border: none;
		.line1 {
			font-size: 18px;
			color: #fff;
			margin-bottom: 2px;
		}
		.line2 {
			font-size: 12px;
			color: #fff;
		}
	}
	.rinkBox {
		.adImg{
			cursor:pointer;
			width: 250px;
		}
		
	}
}
.carousel {
	width: 360px;
	height: 100px;
	.carouselItem {
		width: 87px;
		height: 87px;
	}
}
.detailBox {
	display: flex;
	background-color: #fff;
	padding: 17px 26px;
	.titleDe {
		color: #0d0303;
		font-weight: 700;
		font-size: 18px;
	}
	.left {
		flex: 1;
	}
	.right {
		width: 260px;
		padding: 30px;
		box-sizing: border-box;
		.qrcodeBox{
			display: flex;
			flex-direction: column;
			align-items: center;
			font-size: 24px;
			color: #222;
			    /* padding: 0 5px;
			    text-align: center;
			    font-size: 24px;
			    color: #222;
			    height: 80px;
			    line-height: 80px; */
			>div{
				width: 200px;
				height: 200px;
				margin-top: 24px;
			}
		}
		.qrcode-desc{
			font-size: 14px;
			line-height: 24px;
			color: #707070;
			text-align: center;
			margin: 10px 0;
		}
		.title {
			font-size: 24px;
			color: #222;
			font-size: 24px;
			line-height: 60px;
			text-align:center;
		}
		.recommend {
			> img {
				width: 200px;
				height: 200px;
			}
			> p {
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2; //这边的2指的是两行
				-webkit-box-orient: vertical;
				margin: 13px 20px;
			}
		}
	}
}
.vueMagnify{
	width: 350px;
	height: 350px;
}
.exchange-tips {
	color: #fe4706;
}
</style>
